import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=4b229ee1&scoped=true&"
import script from "./Price.js?vue&type=script&lang=js&"
export * from "./Price.js?vue&type=script&lang=js&"
import style0 from "./Price.css?vue&type=style&index=0&id=4b229ee1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b229ee1",
  null
  
)

export default component.exports